import ROUTES from './routes';
import {
  COMMUNITY_TYPES,
  USER_STATUS_INVITED,
  USER_STATUS_CREATED,
  USER_STATUS_JOINED,
} from './props';
import { ASSIGNMENT_METHOD } from '../redux/surveys/constants';
import { TODO_ASSIGNMENT_METHOD } from '../redux/healthboard/constants';

// Strings
export const DAY_FORMATTING_PATTERN = {
  id: 'general.formats.dayFormattingPattern',
};
export const DAY_MONTH_FORMAT = 'd MMM';
export const DATE_PATTERN_API = { id: 'general.formats.datePatternAPI' };
export const DATE_PATTERN_UI = { id: 'general.formats.datePatternUI' };
export const SHORT_DATE_PATTERN = { id: 'general.formats.shortDatePattern' };
export const FULL_SHORT_DATE_PATTERN = {
  id: 'general.formats.fullShortDatePattern',
};
export const TIME_PATTERN = { id: 'general.formats.timePattern' };
export const CHAT_EMPTY = { id: 'messages.chat.empty.messages' };
export const CHAT_EMPTY_NAVIGATION = { id: 'messages.chat.empty.users' };
export const CHAT_EMPTY_CHANNELS = { id: 'messages.chat.empty.channels' };
export const ERROR_404 = { id: 'general.errors.404' };
export const TO_TOP = { id: 'general.toTop' };
export const SUCCESS = { id: 'general.success' };
export const REMOVE_FROM_CHAT = { id: 'general.removedFromChat' };
export const PICK_ITEM_LEFT = { id: 'general.labels.pickItemLeft' };

export const PLACEHOLDER_SEARCH_MESSAGE = { id: 'general.search.placeholder' };
export const PROFILE_FIELDSET_EMPTY = { id: 'profile.fieldSet.empty' };
export const PROGRAM_INVITATION_TEXT = {
  id: 'programs.invitation.invitationText',
};
export const SURVEYS_UPCOMING_EMPTY = { id: 'surveys.noUpcomingSurveys' };
export const SURVEYS_ANSWERED_EMPTY = { id: 'surveys.noSurveysResults' };
export const SURVEYS_TITLE = { id: 'surveys.title' };
export const PROGRAMS_TITLE = { id: 'programs.title' };
export const SURVEY_RESULTS = { id: 'surveys.results' };

export const SUCCESS_SURVEY_COMPLETION = { id: 'surveys.completion' };
export const SUCCESS_SEND_SURVEY = { id: 'surveys.sent' };
export const SUCCESS_ANSWER_SURVEY = { id: 'surveys.answer' };
export const SUCCESS_ANSWER_FORM = { id: 'surveys.answerForm' };
export const SUCCESS_UPDATE_PROFILE = { id: 'profiles.updated' };
export const SUCCESS_PATIENT_ADDED = { id: 'dialog.common.patientWasAdded' };
export const SUCCESS_UPDATE_SETTINGS = { id: 'settings.updated' };
export const SUCCESS_UNASSIGNED = { id: 'circle.unassigned' };
export const SUCCESS_ASSIGNED = { id: 'circle.assigned' };

export const CONFIRM_UNASSIGNED = { id: 'circle.confirmUnassigned' };

export const SEARCH_SIDEBAR_PROVIDER = { id: 'general.search.patients' };
export const SEARCH_SIDEBAR_USER = { id: 'general.search.placeholder' };
export const YOU = { id: 'general.labels.you' };
export const OFFLINE_MESSAGE = { id: 'general.labels.noInternet' };
export const YO = { id: 'general.labels.YO' };
export const MY_PROFILE = { id: 'general.labels.myProfile' };
export const PROFILE_STR = { id: 'general.labels.profile' };
export const CIRCLES_EMPTY = { id: 'circles.empty' };
export const CIRCLES_EMPTY_NAVIGATION = { id: 'circles.empty.navigation' };
export const FAMILY_TITLE = { id: 'messages.userProfile.familyMembers' };
export const PROGRAM_PROVIDERS_TITLE = {
  id: 'messages.userProfile.programServiceProviders',
};
export const CARE_PROVIDERS_TITLE = { id: 'general.careProvidersTitle' };
export const CARE_PROVIDER = { id: 'messages.userProfile.singleProvider' };
export const TOGGLE_TNC = { id: 'general.labels.backToInvitation' };
export const MAIN_CARE_PROVIDER = {
  id: 'messages.userProfile.mainProvider',
};
export const MEMBER_PROVIDER_CIRCLE = {
  id: 'messages.userProfile.memberProviderCircle',
};
export const USERNAME_EXAMPLE = { id: 'general.labels.userNameExample' };
export const USERNAME_EXPLANATION = {
  id: 'general.labels.userNameExplanation',
};

export const COMMUNITIES_EMPTY_NAVIGATION = {
  id: 'communities.empty.navigation',
};
export const COMMUNITIES_EMPTY = { id: 'communities.empty' };
export const COMMUNITIES_EMPTY_ACTIVITIES = {
  id: 'communities.empty.activities',
};
export const COMMUNITIES_TITLE_MEMBER = { id: 'communities.title.member' };
export const COMMUNITIES_TITLE_MODERATOR = {
  id: 'communities.title.moderator',
};

export const COMMUNITY_TYPE_PUBLIC = { id: 'community.type.public' };
export const COMMUNITY_TYPE_PRIVATE = { id: 'community.type.private' };
export const COMMUNITY_ACCESS_READ_ONLY = { id: 'community.access.readOnly' };

export const COMMUNITY_EMPTY = { id: 'community.empty' };
export const COMMUNITY_DESCRIPTION = { id: 'community.description' };
export const COMMUNITY_POSTS = { id: 'community.posts' };
export const COMMUNITY_POSTS_EMPTY = { id: 'community.posts.empty' };
export const COMMUNITY_POSTS_PRIVATE = { id: 'community.posts.private' };
export const COMMUNITY_POSTS_EMPTY_SUB = {
  id: 'community.posts.privateSubtitle',
};
export const COMMUNITY_MEMBERS = { id: 'community.members' };
export const COMMUNITY_MEMBERS_LIST = { id: 'community.membersList' };
export const COMMUNITY_MODERATORS_LIST = { id: 'community.moderatorsList' };
export const COMMUNITY_POST_UPDATED = { id: 'community.postUpdated' };
export const COMMUNITY_COMMENT_UPDATED = { id: 'community.postUpdated' };

export const COMMUNITY_ACTIVITY = { id: 'community.activity.total' };
export const COMMUNITY_ACTIVITY_POSTS = { id: 'community.activity.posts' };
export const COMMUNITY_ACTIVITY_COMMENTS = {
  id: 'community.activity.comments',
};
export const COMMUNITY_ACTIVITY_REQUEST = {
  id: 'community.activity.sentRequest',
};
export const COMMUNITY_ACTIVITY_ACCEPTED_REQUEST = {
  id: 'community.activity.requestAccepted',
};
export const COMMUNITY_ACTIVITY_DECLINED_REQUEST = {
  id: 'community.activity.requestDeclined',
};

export const POST_TITLE = { id: 'post.title' };
export const POST_BACK = { id: 'post.back' };
export const POST_COMMENTS = { id: 'post.comments' };
export const POST_COMMENTS_ADD = { id: 'post.comments.add' };
export const POST_COMMENT_DESCRIPTION = { id: 'post.comment.description' };
export const POST_REPLIES = { id: 'post.replies' };
export const POST_REPLY_DESCRIPTION = { id: 'post.reply.description' };
export const POST_REPLY_PLACEHOLDER = { id: 'post.reply.placeholder' };

export const SUCCESS_PAYMENT_METHOD_REMOVED = {
  id: 'profile.payment.removeSuccessfullyMessage',
};

export const REPORT = {
  title: { id: 'report.title' },
  danger: { id: 'report.danger' },
};

export const ROLE_ADMIN = { id: 'role.admin' };

export const NEW_CHAT = {
  addMorePeople: { id: 'dialog.common.invite' },
  newChat: { id: 'messages.chat.newChat' },
  startANewConversationInTheContextOf: {
    id: 'messages.chat.startANewConversationInTheContextOf',
  },
  startANewConversationInTheContextOfDesc: {
    id: 'messages.chat.startANewConversationInTheContextOfDesc',
  },
  startANewConversation: { id: 'messages.chat.startANewConversation' },
  findAMember: { id: 'messages.chat.findAMember' },
  youAddedMembers: { id: 'messages.chat.youAddedMembers' },
  counterMembers: { id: 'messages.chat.counterMembers' },
  start: { id: 'messages.chat.start' },
  noOneFound: { id: 'messages.chat.noOneFound' },
  enterUsernameOrName: { id: 'messages.chat.enterUsernameOrName' },
  searchPeopleByUsername: { id: 'general.search.searchByPeopleUsername' },
  searchAUser: { id: 'messages.chat.searchAUser' },
  defaultUser: { id: 'messages.chat.defaultUser' },
  accessLevel: { id: 'messages.titles.accessLevel' },
  accessLevelTooltip: { id: 'messages.titles.accessLevelTooltip' },
  reasonForAssignment: { id: 'messages.titles.reasonForAssignment' },
  selectReasonForAssignment: {
    id: 'messages.titles.selectReasonForAssignment',
  },
};

export const MENU = {
  healthboard: { id: 'menu.healthboard' },
  messages: { id: 'menu.messages' },
  myCircles: { id: 'menu.myCircles' },
  dashboard: { id: 'menu.dashboard' },
  communities: { id: 'menu.communities' },
  home: { id: 'menu.home' },
};

export const MESSAGES_FILTER_OPTIONS = {
  allPatients: { id: 'messages.filterOptions.allPatients' },
  myPatients: { id: 'messages.filterOptions.myPatients' },
};

export const MESSAGES_STATUS_FILTER_OPTIONS = {
  all: { id: 'messages.statusFilterOptions.all' },
  joined: { id: 'messages.statusFilterOptions.joined' },
  notJoined: { id: 'messages.statusFilterOptions.notJoined' },
};

export const MESSAGES_NOT_JOINED = {
  message: { id: 'messages.patientNotJoined.message' },
  resend: { id: 'messages.patientNotJoined.resend' },
  noAvailableSurveys: { id: 'surveys.sendSurvey.noSurveys' },
  noAvailableForms: { id: 'surveys.noAvailableForms' },
  invite: { id: 'messages.patientNotJoined.invite' },
  inviteSent: { id: 'messages.patientNotJoined.inviteSent' },
  checkContactInformationText: {
    id: 'messages.patientNotJoined.checkContactInformationText',
  },
  inviteTitle: { id: 'messages.patientNotJoined.inviteTitle' },
  errors: {
    // phoneNumber: {
    //   invalid: { id: 'messages.patientNotJoined.errors.invalid' },
    //   already_taken: { id: 'messages.patientNotJoined.errors.phoneNumberAlreadyTaken' },
    // },
    // email: {
    //   invalid: { id: 'messages.patientNotJoined.errors.invalid' },
    //   already_taken: { id: 'messages.patientNotJoined.errors.emailAlreadyTaken' },
    // },
    // meta validation errors
    phoneNumber_taken: {
      id: 'messages.patientNotJoined.errors.phoneNumberAlreadyTaken',
    },
    phoneNumber_invalid: {
      id: 'messages.patientNotJoined.errors.phoneNumberInvalid',
    },
    phoneNumber_blank: {
      id: 'messages.patientNotJoined.errors.phoneNumberBlank',
    },

    email_taken: {
      id: 'messages.patientNotJoined.errors.emailAlreadyTaken',
    },
    email_invalid: { id: 'messages.patientNotJoined.errors.emailInvalid' },
    email_blank: { id: 'messages.patientNotJoined.errors.emailBlank' },
    // // one code
    // invalid: { id: 'messages.patientNotJoined.errors.invalid' },
    // record_invalid: { id: 'messages.patientNotJoined.errors.invalid' },
    // already_taken: { id: 'messages.patientNotJoined.errors.phoneNumberAlreadyTaken' },
  },
};

export const TITLE = { id: 'general.title' };

// pending invitations
export const CANCEL_INVITE = {
  title: { id: 'circles.family.cancelInvite.title' },
  text: { id: 'circles.family.cancelInvite.text' },
};

export const CANCEL_CAREGIVER_INVITE = {
  title: { id: 'circles.caregiver.cancelInvite.title' },
  text: { id: 'circles.caregiver.cancelInvite.text' },
};

export const CANCEL_INVITATION = { id: 'circles.invites.cancelInvite' };
export const CONFIRM_CANCEL = { id: 'circles.invites.confirmCancel' };
export const DECLINE_CANCEL = { id: 'circles.invites.declineCancel' };
export const INVITE_SENT = { id: 'circles.invites.inviteSent' };
export const INVITED_CAREGIVER = { id: 'circles.invites.invitedCaregiver' };
export const SUCCESS_INVITE_FAMILY = { id: 'circles.invites.family.success' };
export const SUCCESS_INVITE_CAREGIVER = {
  id: 'circles.invites.caregiver.success',
};
export const SUCCESS_INVITE_PROVIDER = {
  id: 'circles.invites.provider.success',
};
export const ERROR_ASSIGN_CAREGIVER = { id: 'circles.invites.caregiver.error' };

export const ACCEPT_FAMILY_INVITATION = { id: 'circles.invites.family.accept' };
export const DECLINE_FAMILY_INVITATION = {
  id: 'circles.invites.family.decline',
};
export const ACCEPT_CAREGIVER_INVITATION = {
  id: 'circles.invites.caregiver.accept',
};
export const DECLINE_CAREGIVER_INVITATION = {
  id: 'circles.invites.caregiver.decline',
};

export const SUCCESS_REMOVE_PROVIDER = { id: 'circles.provider.remove' };
export const SUCCESS_LEAVE_PROVIDER_CIRCLE = { id: 'circles.provider.leave' };
export const SUCCESS_REMOVE_FAMILY_MEMBER = { id: 'circles.family.remove' };
export const SUCCESS_LEAVE_FAMILY = { id: 'circles.family.leave' };

export const COMMON = {
  addPatient: { id: 'common.addPatient' },
  remove: { id: 'common.remove' },
  accept: { id: 'common.accept' },
  decline: { id: 'common.decline' },
  back: { id: 'common.back' },
  cancel: { id: 'common.cancel' },
  save: { id: 'common.save' },
  invite: { id: 'common.invite' },
  terms: { id: 'common.terms' },
  termOfUse: { id: 'common.termOfUse' },
  yes: { id: 'common.yes' },
  no: { id: 'common.no' },
  close: { id: 'common.close' },
  clear: { id: 'common.clear' },
  collapse: { id: 'common.collapse' },
  myMessages: { id: 'common.myMessages' },
  myHealthboard: { id: 'common.myHealthboard' },
  myCommunities: { id: 'common.myCommunities' },
  reports: { id: 'common.reports' },
  discover: { id: 'common.discover' },
  add: { id: 'common.add' },
  unassign: { id: 'common.unassign' },
  optional: { id: 'common.optional' },
  privacy: { id: 'common.privacy' },
  from: { id: 'common.from' },
  notifications: { id: 'common.notifications' },
  allow: { id: 'common.allow' },
  copy: { id: 'common.copy' },
  likes: { id: 'common.likes' },
  comments: { id: 'common.comments' },
  new: { id: 'common.new' },
  send: { id: 'common.send' },
  emptySection: { id: 'common.emptySection' },
  next: { id: 'common.next' },
  activities: { id: 'common.activities' },
};

// Text blocks
export const ACTIONS = {
  circle: {
    leave: { id: 'circles.actions.leave' },
  },
  survey: {
    answer: { id: 'surveys.actions.answer' },
    save: { id: 'surveys.actions.save' },
    proceed: { id: 'surveys.actions.proceed' },
    general: { id: 'surveys.actions.general' },
    review: { id: 'surveys.actions.review' },
    submit: { id: 'surveys.actions.submit' },
    submitOne: { id: 'surveys.actions.submitOne' },
    upcoming: { id: 'surveys.actions.upcoming' },
    upcomingHeading: { id: 'surveys.actions.upcomingHeading' },
    exportToPDF: { id: 'surveys.actions.exportToPDF' },
    title: { id: 'surveys.title' },
    countSurveys: { id: 'surveys.countSurveys' },
    single: { id: 'surveys.single' },
    totalScore: { id: 'surveys.totalScore' },
    selectedChatDesc: { id: 'surveys.selectedChatDesc' },
    answeredBy: { id: 'surveys.answeredBy' },
    complete: { id: 'common.complete' },
    optional: { id: 'common.optional' },
  },
  program: {
    request: { id: 'programs.actions.request' },
    title: { id: 'programs.actions.title' },
    followup: { id: 'programs.actions.followup' },
    subtitle: { id: 'programs.actions.subtitle' },
    showMore: { id: 'programs.actions.showMore' },
    showLess: { id: 'programs.actions.showLess' },
    more: { id: 'programs.actions.more' },
    leave: { id: 'programs.actions.leave' },
    emptyState: { id: 'programs.emptyState' },
    aboutProgram: { id: 'programs.actions.aboutProgram' },
  },
  profile: {
    cancel: { id: 'profile.actions.cancel' },
    details: { id: 'profile.actions.details' },
    submit: { id: 'profile.actions.submit' },
    provider: { id: 'profile.actions.provider' },
    patient: { id: 'profile.actions.patient' },
    back: { id: 'profile.actions.back' },
  },
  chat: {
    downloadAttachment: { id: 'chat.actions.downloadAttachment' },
    editMessage: { id: 'chat.actions.editMessage' },
    deleteMessage: { id: 'chat.actions.deleteMessage' },
    confirmDeleteMessage: { id: 'chat.actions.confirmDeleteMessage' },
    reply: { id: 'chat.actions.reply' },
    blockMessaging: { id: 'chat.actions.blockMessaging' },
    unblockMessaging: { id: 'chat.actions.unblockMessaging' },
    unblockUser: { id: 'chat.actions.unblockUser' },
    leaveChat: { id: 'chat.actions.leaveChat' },
    confirmLeaveChat: { id: 'chat.actions.confirmLeaveChat' },
    sendMessage: { id: 'chat.actions.sendMessage' },
  },
  community: {
    createPost: { id: 'community.actions.createPost' },
    leave: { id: 'community.activity.leave' },
  },
  post: {
    createComment: { id: 'post.actions.createComment' },
    reply: { id: 'post.actions.reply' },
  },
};

export const PROGRAMS = {
  invitations: {
    title: { id: 'programs.invitation.title' },
    empty: { id: 'programs.invitation.empty' },
    emptyState: { id: 'programs.invitation.emptyState' },
    addPatient: { id: 'programs.invitation.addPatient' },
    success: { id: 'programs.invitation.success' },
  },
  remove: {
    confirmRemove: { id: 'programs.remove.confirmRemove' },
    success: { id: 'programs.remove.success' },
    title: { id: 'programs.remove.title' },
    subtitle: { id: 'programs.remove.subtitle' },
  },
};

export const AUTH = {
  actions: {
    accessDenied: {
      textTitle: { id: 'auth.accessDenied.text' },
    },
    createPassword: {
      textTitle: { id: 'auth.createPassword.text' },
    },
    expiredToken: {
      textTitle: { id: 'auth.expiredToken.text' },
    },
    expiredConfirmation: {
      textTitle: { id: 'auth.expiredConfirmation.text' },
    },
    otp: {
      textLink: { id: 'auth.sendOtp.title' },
    },
    recoverConfirm: {
      email: {
        textTitle: { id: 'auth.recoverConfirm.email.title' },
        textConfirm: { id: 'auth.recoverConfirm.email.confirmText' },
      },
      phone: {
        textTitle: { id: 'auth.recoverConfirm.phone.title' },
        textConfirm: { id: 'auth.recoverConfirm.phone.confirmText' },
      },
    },
    recoverPassword: {
      textTitle: { id: 'auth.recoverPassword.textTitle' },
      textTitlePrimaryContacts: {
        id: 'auth.recoverPassword.primaryContacts.textTitle',
      },
      textLink: { id: 'auth.recoverPassword.textLink' },
    },
    userNotFound: {
      textTitle: { id: 'auth.userNotFound.text' },
    },
    signup: {
      textTitle: { id: 'auth.signup.title' },
      textLink: { id: 'auth.signup.textLink' },
      matchPassword: { id: 'auth.signup.matchPassword' },
      confirmationPassword: { id: 'auth.signup.confirmationPassword' },
    },
    tnc: {
      textTitle: { id: 'auth.tnc.title' },
      textLink: { id: 'auth.tnc.textLink' },
    },
    logout: { id: 'auth.logout.text' },
  },
  errors: {
    common: { id: 'errors.common' },
    invalidDate: { id: 'errors.invalidDateOfBirth' },
    login: {
      unauthorized: { id: 'errors.login.unauthorized' },
      authenticationLockout: { id: 'errors.login.authenticationLockout' },
    },
    namesLength: { id: 'errors.nameLength' },
    requiredFields: { id: 'errors.requiredFields' },
    tnc: { id: 'errors.tnc' },
    cannotAcceptInvite: { id: 'errors.cannotAcceptInvite' },
    containsCommercialAt: { id: 'errors.nicknameContainsCommercialAt' },
    password: { id: 'errors.password' },
  },
  fields: {
    dob: { id: 'fields.dob' },
    email: { id: 'fields.email' },
    firstname: { id: 'fields.firstname' },
    gender: { id: 'fields.gender' },
    lastname: { id: 'fields.lastname' },
    password: { id: 'fields.password' },
    username: { id: 'profile.fields.username' },
    login: { id: 'fields.login' },
    loginPlaceholder: { id: 'fields.login.placeholder' },
    phoneNumber: { id: 'fields.phoneNumber' },
  },
  submit: {
    signup: { id: 'submit.signup' },
    login: { id: 'submit.login' },
    signin: { id: 'submit.signin' },
    loginAzure: { id: 'submit.login.azure' },
    signUpAzure: { id: 'submit.signUp.azure' },
    fillProfile: { id: 'submit.fillProfile' },
    recoverPassword: { id: 'submit.recoverPassword' },
    recoverConfirm: { id: 'submit.recoverConfirm' },
    createPassword: { id: 'submit.createPassword' },
    expiredToken: { id: 'submit.expiredToken' },
    signUp: { id: 'submit.signUp' },
  },
  titles: {
    accessDenied: { id: 'titles.accessDenied' },
    createPassword: { id: 'titles.createPassword' },
    expiredToken: { id: 'titles.expiredToken' },
    expiredConfirmation: { id: 'titles.expiredConfirmation' },
    fillProfile: { id: 'titles.fillProfile' },
    login: { id: 'titles.login' },
    recoverConfirm: { id: 'titles.recoverConfirm' },
    recoverPassword: { id: 'titles.recoverPassword' },
    signup: { id: 'titles.signup' },
    confirmMyEmail: { id: 'titles.confirmMyEmail' },
    confirmMyPhoneNumber: { id: 'titles.confirmMyPhoneNumber' },
    invitationLinkDesc: { id: 'auth.signup.invitationLinkDesc' },
    sentEmailVerification: { id: 'auth.signup.sentEmailVerification' },
    sentPhoneVerification: { id: 'auth.signup.sentPhoneVerification' },
  },
};

export const PROFILE = {
  avatar: {
    remove: { id: 'profile.avatar.remove' },
    upload: { id: 'profile.avatar.upload' },
    update: { id: 'profile.avatar.update' },
  },
  tabType: {
    patient: { id: 'profile.tabType.patient' },
    provider: { id: 'profile.tabType.provider' },
    surveys: { id: 'profile.tabType.surveys' },
    team: { id: 'profile.tabType.team' },
  },
  notificationSettings: {
    title: { id: 'profile.section.notificationSettings' },
    label: { id: 'profile.notificationSettings.label' },
    labels: {
      email: { id: 'profile.notificationSettings.labels.email' },
      sms: { id: 'profile.notificationSettings.labels.sms' },
    },
  },
  languageSettings: {
    title: { id: 'profile.section.languageSettings' },
  },
  deviceSetup: {
    title: { id: 'profile.section.deviceSetup' },
    addDeviceAccount: { id: 'profile.section.deviceSetup.addDeviceAccount' },
    noAccount: { id: 'profile.section.deviceSetup.noAccount' },
    addAccountDescription: {
      id: 'profile.section.deviceSetup.addAccountDescription',
    },
    removeAccount: { id: 'profile.section.deviceSetup.removeAccount' },
    detailsAccount: { id: 'profile.section.deviceSetup.detailsAccount' },
    noDevices: { id: 'profile.section.deviceSetup.noDevices' },
    synced: { id: 'profile.section.deviceSetup.synced' },
    noPermission: { id: 'profile.section.deviceSetup.noPermission' },
    noPermissionAnnotation: {
      id: 'profile.section.deviceSetup.noPermissionAnnotation',
    },
    error: { id: 'errors.common' },
    appleHealth: { id: 'profile.section.deviceSetup.appleHealth' },
    appleHealthDescription: {
      id: 'profile.section.deviceSetup.manageDataFromMobile',
    },
  },
  edit: {
    emailConfirmationTitle: { id: 'profile.edit.emailConfirmationTitle' },
    confirmCode: { id: 'profile.edit.confirmCode' },
    invalidCode: { id: 'profile.edit.invalidCode' },
    emailConfirmationText: { id: 'profile.edit.emailConfirmationText' },
    phoneConfirmationText: { id: 'profile.edit.phoneConfirmationText' },
  },
  errors: {
    email: {
      taken: { id: 'messages.patientNotJoined.errors.emailAlreadyTaken' },
      invalid: { id: 'messages.patientNotJoined.errors.emailInvalid' },
      blank: { id: 'messages.patientNotJoined.errors.emailBlank' },
    },
    phoneNumber: {
      taken: {
        id: 'messages.patientNotJoined.errors.phoneNumberAlreadyTaken',
      },
      invalid: { id: 'messages.patientNotJoined.errors.phoneNumberInvalid' },
      blank: { id: 'messages.patientNotJoined.errors.phoneNumberBlank' },
    },
    username: {
      taken: { id: 'errors.username.alreadyTaken' },
      conflicts_with_existing_phone_number: {
        id: 'errors.username.conflictsWithExistingData',
      },
      conflicts_with_existing_email: { id: 'errors.username.alreadyTaken' },
      required: { id: 'errors.username.required' },
    },
    aliasName: {
      taken: { id: 'errors.aliasName.alreadyTaken' },
    },
    ssn: {
      taken: { id: 'errors.ssn.alreadyTaken' },
    },
  },
};

/*
 * TODO add real text for provider circle invitation
 */

export const INVITE_MEMBER = {
  title: { id: 'circles.invites.title' },
  subtitle: { id: 'circles.invites.subtitle' },
};

export const INVITE_TEXT = {
  role: { id: 'circles.invites.role' },
  family: { id: 'circles.invites.text.family' },
  provider: { id: 'circles.invites.text.provider' },
  caregiver: { id: 'circles.invites.text.caregiver' },
  guardian: { id: 'circles.invites.text.guardian' },
  providerInvitesCaregiver: {
    id: 'circles.invites.text.ProviderInvitesCaregiver',
  },
};

export const MAKE_IBVITE_CAREGIVER = { id: 'circles.invites.caregiver' };
export const MAKE_INVITE_TO_FAMILY_TEXT = {
  id: 'circles.invites.makeInviteToFamilyText',
};
export const MAKE_INVITE_TO_PROVIDER_TEXT = {
  id: 'circles.invites.makeInviteProviderText',
};
export const MAKE_INVITE_CAREGIVER_TEXT = {
  id: 'circles.invites.makeInviteCaregiverText',
};

export const PASS_STRENGTH = [
  'Too weak!',
  'Weak!',
  'Medium',
  'Good',
  'Very good',
];

// method for localisation convertRelationsList
// TODO use from data constants
export const FAMILY_MEMBERS_OPTIONS = [
  { value: 'spouse' },
  { value: 'daughter' },
  { value: 'son' },
  { value: 'sister' },
  { value: 'brother' },
  { value: 'mother' },
  { value: 'father' },
  { value: 'granddaughter' },
  { value: 'grandson' },
  { value: 'grandmother' },
  { value: 'grandfather' },
  { value: 'partner' },
  { value: 'relative' },
  { value: 'friend' },
];

export const PARENT_OPTIONS = [{ value: 'mother' }, { value: 'father' }];

export const ADD_PROVIDER_OPTION = [
  { value: 'temporary', label: 'circles.addProviderReason.temporaryTitle' },
  { value: 'permanent', label: 'circles.addProviderReason.permanentTitle' },
];

export const ADD_PROVIDER_REASON_CODE = {
  temporary: [
    {
      value: 'emergency access',
      label: 'circles.addProviderReason.temporary.emergencyAccess',
    },
    {
      value: 'temporarily assigned to patient',
      label: 'circles.addProviderReason.temporary.temporarilyAssigned',
    },
    {
      value: 'patient consultation',
      label: 'circles.addProviderReason.temporary.patientConsultation',
    },
  ],
  permanent: [
    {
      value: 'current patient under treatment',
      label: 'circles.addProviderReason.permanent.underTreatment',
    },
    {
      value: 'patient request',
      label: 'circles.addProviderReason.permanent.patientRequest',
    },
  ],
};

// Don't touch, it is not really i18n strings
export const PATIENT_PROFILE = 'primaryPatientProfile';
export const PROVIDER_PROFILE = 'primaryProviderProfile';
export const CIRCLE_FAMILY = 'family';
export const CIRCLE_PROVIDER = 'provider';
export const CIRCLE_CAREGIVER = 'caregiver';
export const CIRCLE_DEPENDENTS = 'guardian';
export const TEAM_PROFILE = 'team';
export const CIRCLE_INVITE = 'invite';
export const PENDING_INVITATIONS = { id: 'circles.invites.pending' };

export const CIRCLES = {
  notInCircle: { id: 'circle.notInCircle' },
  circle: { id: 'circles.circle' },
  titles: {
    invitations: { id: 'circles.titles.invitations' },
    listCaregiver: { id: 'circles.titles.listCaregiver' },
    familyMemberingCircle: { id: 'circles.titles.familyMemberingCircle' },
    listFamilyCircleMember: { id: 'circles.titles.listFamilyCircleMember' },
    listProviderMember: { id: 'circles.titles.listProviderMember' },
    guardianFor: { id: 'circles.titles.guardianFor' },
    familyCircle: { id: 'circles.titles.familyCircle' },
    providerCircle: { id: 'circles.titles.providerCircle' },
    primaryProviderProfileTitle: {
      id: 'circles.titles.primaryProviderProfileTitle',
    },
    primaryPatientProfileTitle: {
      id: 'circles.titles.primaryPatientProfileTitle',
    },
    caregiverRole: { id: 'circles.titles.caregiverRole' },
    careProvider: { id: 'circles.titles.careProvider' },
    guardianRole: { id: 'circles.roles.guardian' },
    proxyRole: { id: 'circles.roles.proxy' },
    parentRole: { id: 'circles.roles.parent' },
  },
  leaveBtn: { id: 'circles.actions.leaveBtn' },
  actionTitles: {
    makeCaregiver: { id: 'circles.actions.makeCaregiver' },
    removeFromCircle: { id: 'circles.actions.removeFromCircle' },
  },
  inviteProvider: { id: 'circles.actions.inviteProvider' },
  inviteFamily: { id: 'circles.actions.inviteFamily' },
  inviteCaregiver: { id: 'circles.actions.makeCaregiver' },
  circleTitle: { id: 'circles.circle.typedCircle' },
  removeCaregiver: { id: 'circles.actions.removeCaregiver' },
  assignCaregiver: { id: 'circles.actions.makeCaregiver' },
  assignGuardian: { id: 'circles.actions.assignGuardian' },
  removeGuardian: { id: 'circles.actions.removeGuardian' },
};

export const VALIDATION_ERRORS = {
  profile: {
    firstName: {
      required: { id: 'errors.validation.profile.firstName.required' },
    },
    lastName: {
      required: { id: 'errors.validation.profile.lastName.required' },
    },
    phone: {
      format: { id: 'errors.validation.profile.phone.format' },
      required: { id: 'errors.validation.profile.phone.required' },
      short: { id: 'errors.validation.profile.phone.short' },
    },
    dob: {
      format: { id: 'errors.validation.profile.dob.format' },
      required: { id: 'errors.validation.profile.dob.required' },
    },
    email: {
      format: { id: 'errors.validation.profile.email.format' },
      required: { id: 'errors.validation.profile.email.required' },
    },
    username: {
      required: { id: 'errors.validation.profile.username.required' },
      format: { id: 'errors.validation.profile.username.format' },
      minCharacters: { id: 'errors.validation.profile.username.minCharacters' },
    },
    aliasName: {
      required: { id: 'errors.validation.profile.aliasName.required' },
      format: { id: 'errors.validation.profile.aliasName.format' },
      minCharacters: {
        id: 'errors.validation.profile.aliasName.minCharacters',
      },
    },
    postalCode: {
      format: { id: 'errors.validation.profile.postalCode.format' },
    },
    ssn: {
      format: { id: 'errors.validation.profile.ssn.format' },
    },
    phoneHome: {
      required: {
        id: 'errors.validation.profile.phoneHome.required',
      },
      format: { id: 'errors.validation.profile.phoneHome.format' },
    },
    workingHours: {
      required: {
        id: 'errors.validation.profile.workingHours.required',
      },
    },
  },
};

export const MESSAGES = {
  familyTitleWithCounter: { id: 'messages.titles.familyTitleWithCounter' },
  providerTitleWithCounter: {
    id: 'messages.titles.providerTitleWithCounter',
  },
};

export const LEAVE_FAMILY_CIRCLE_STRINGS = {
  title: { id: 'circles.leave.family.title' },
  body: { id: 'circles.leave.family.body' },
};

export const LEAVE_PROVIDER_CIRCLE_STRINGS = {
  title: { id: 'circles.leave.provider.title' },
  body: { id: 'circles.leave.provider.body' },
};

export const COMMON_ERROR_MESSAGES = {
  error: { id: 'errors.commonErrorOccured' },
  emailError: { id: 'errors.emailError' },
  descr: { id: 'errors.emailErrorDesription' },
  emailAndPhoneError: { id: 'errors.emailAndPhoneErrorDescription' },
  alreadyUsed: { id: 'errors.alreadyUsed' },
};

export const PREVIEWABLE_BLOCK = {
  viewMore: { id: 'previewableBlock.more' },
  viewLess: { id: 'previewableBlock.less' },
};

export const CHAT = {
  uploadingFileInProgress: { id: 'chat.titles.uploadingFile' },
  messageIsLong: { id: 'chat.errors.tooLong' },
  attachmentMaxSizeExceeded: { id: 'chat.errors.maxAttachmentSize' },
  attachmentMaxSizeNextPart: { id: 'chat.errors.maxAttachmentSizeNextPart' },
  attachmentNotAllowedFormat: { id: 'chat.errors.notAllowedFormat' },
  attachmentUploadError: { id: 'chat.errors.uploadError' },
  attachmentMaxNumber: { id: 'chat.errors.maxAttachmentNumber' },
  titles: {
    generalChatTab: { id: 'chat.titles.generalChatTab' },
    familyChatTab: { id: 'chat.titles.familyChatTab' },
    providersChatTab: { id: 'chat.titles.providersChatTab' },
    activitiesChatTab: { id: 'chat.titles.activitiesChatTab' },
    notificationsChatTab: { id: 'chat.titles.notificationsChatTab' },
    healthAlert: { id: 'chat.titles.healthAlert' },
    providerAssigned: { id: 'chat.titles.providerAssignment' },
    providerRemoved: { id: 'chat.titles.providerRemoved' },
    memberAssigned: { id: 'chat.titles.memberAssignment' },
    notification: { id: 'chat.titles.notification' },
    upcomingSurveyReminder: { id: 'chat.titles.surveyReminder' },
    addedAttachment: { id: 'chat.titles.addedAttachment' },
    provider: { id: 'chat.titles.provider' },
    providers: { id: 'chat.titles.providers' },
    family: { id: 'chat.titles.family' },
    chatName: { id: 'chat.title.chatName' },
    userBlocked: { id: 'chat.title.userBlocked' },
    newChatError: { id: 'chat.title.newChatError' },
    disclaimerInforming: { id: 'chat.title.disclaimerInforming' },
  },
  placeholders: {
    messageTo: { id: 'chat.placeholders.messageTo' },
    default: { id: 'chat.placeholders.default' },
    upcomingSurveyExpired: { id: 'chat.placeholders.surveyExpired' },
  },
  notifications: {
    patientAssignedToProgram: {
      id: 'chat.notifications.patientAssignedToProgram',
    },
    patientRemovedFromProgram: {
      id: 'chat.notifications.patientRemovedFromProgram',
    },
  },
  sorting: {
    byUnread: { id: 'chat.sorting.byUnread' },
    byLastMessage: { id: 'chat.sorting.byLastMessage' },
  },
  moreAttachments: {
    sendSurvey: { id: 'chat.moreAttachments.sendSurvey' },
    answerForm: { id: 'chat.moreAttachments.answerForm' },
    attachFile: { id: 'chat.moreAttachments.attachFile' },
  },
  chatInContextOf: { id: 'chat.title.chatInContextOf' },
  inContextOf: { id: 'chat.title.inContextOf' },
  conversationInfo: { id: 'chat.title.conversationInfo' },
  newMessage: { id: 'chat.notification.newMessage' },
  removeFromChat: { id: 'chat.common.removeFromChat' },
};

export const GENERAL_SURVEYS = {
  noSurveys: { id: 'generalSurveys.noSurveys' },
};

export const PROFILE_FIELDS = {
  listTitles: {
    emergencyContact: { id: 'profile.section.emergencyContact' },
    general: { id: 'profile.section.general' },
    personal: { id: 'profile.section.personal' },
    contacts: { id: 'profile.section.contacts' },
    health: { id: 'profile.section.health' },
    prof: { id: 'profile.section.prof' },
    mrns: { id: 'profile.section.mrns' },
    empinf: { id: 'profile.section.empinf' },
    address: { id: 'profile.section.address' },
    affiliations: { id: 'profile.section.affiliations' },
    insurance: { id: 'profile.section.insurance' },
  },
  fieldHints: {
    aliasName: { id: 'profile.fields.aliasName.hint' },
    username: { id: 'profile.fields.username.hint' },
  },
  fieldNames: {
    description: { id: 'profile.fields.description' },
    relation: { id: 'profile.fields.relation' },
    bio: { id: 'profile.fields.bio' },
    location: { id: 'profile.fields.location' },
    phones: { id: 'profile.fields.phones' },
    healthInterests: { id: 'profile.fields.healthInterests' },
    name: { id: 'profile.fields.name' },
    firstName: { id: 'profile.fields.firstName' },
    middleName: { id: 'profile.fields.middleName' },
    nameSuffix: { id: 'profile.fields.nameSuffix' },
    lastName: { id: 'profile.fields.lastName' },
    gender: { id: 'profile.fields.gender' },
    genderIdentity: { id: 'profile.fields.genderIdentity' },
    dob: { id: 'profile.fields.dob' },
    age: { id: 'profile.fields.age' },
    educationLevel: { id: 'profile.fields.educationLevel' },
    veteranStatus: { id: 'profile.fields.veteranStatus' },
    citizenship: { id: 'profile.fields.citizenship' },
    mStatus: { id: 'profile.fields.mStatus' },
    ethnic: { id: 'profile.fields.ethnic' },
    language: { id: 'profile.fields.language' },
    languages: { id: 'profile.fields.languages' },
    prefLanguage: { id: 'profile.fields.prefLanguage' },
    religion: { id: 'profile.fields.religion' },
    email: { id: 'profile.fields.email' },
    homeAddress: { id: 'profile.fields.homeAddress' },
    address1: { id: 'profile.fields.address1' },
    address2: { id: 'profile.fields.address2' },
    city: { id: 'profile.fields.city' },
    state: { id: 'profile.fields.state' },
    postalCode: { id: 'profile.fields.postalCode' },
    isHomeLocationDifferent: { id: 'profile.fields.isHomeLocationDifferent' },
    country: { id: 'profile.fields.country' },
    homePhone: { id: 'profile.fields.homePhone' },
    mobilePhone: { id: 'profile.fields.mobilePhone' },
    phoneNumber: { id: 'profile.fields.phone' },
    localUid: { id: 'profile.fields.localUid' },
    allergies: { id: 'profile.fields.allergies' },
    healthConditions: { id: 'profile.fields.healthConditions' },
    medicationAllergies: { id: 'profile.fields.medicationAllergies' },
    medicine: { id: 'profile.fields.medicine' },
    healthGoals: { id: 'profile.fields.healthGoals' },
    role: { id: 'profile.fields.role' },
    mrns: { id: 'profile.fields.mrns' },
    localUidProvider: { id: 'profile.fields.localUidProvider' },
    npi: { id: 'profile.fields.npi' },
    title: { id: 'profile.fields.title' },
    specialty: { id: 'profile.fields.specialty' },
    primaryPracticeAddress: { id: 'profile.fields.primaryPracticeAddress' },
    primaryPracticeAddress1: { id: 'profile.fields.primaryPracticeAddress1' },
    primaryPracticeAddress2: { id: 'profile.fields.primaryPracticeAddress2' },
    primaryPracticeCity: { id: 'profile.fields.primaryPracticeCity' },
    primaryPracticeState: { id: 'profile.fields.primaryPracticeState' },
    primaryPracticeCountry: { id: 'profile.fields.primaryPracticeCountry' },
    officePhone: { id: 'profile.fields.officePhone' },
    username: { id: 'profile.fields.username' },
    aliasName: { id: 'profile.fields.aliasName' },
    day: { id: 'profile.fields.day' },
    year: { id: 'profile.fields.year' },
    month: { id: 'profile.fields.month' },
    organizations: { id: 'profile.fields.organizations' },
    employers: { id: 'profile.fields.employers' },
    ssn: { id: 'profile.fields.ssn' },
    ssnLong: { id: 'profile.fields.ssnLong' },
    insuranceCard: { id: 'profile.fields.insuranceCard' },
    driverLicense: { id: 'profile.fields.driverLicense' },
    weight: { id: 'profile.fields.weight' },
    height: { id: 'profile.fields.height' },
    memberId: { id: 'fields.insurance.memberId' },
    groupNumber: { id: 'fields.insurance.groupNumber' },
    preferredPharmacy: { id: 'appointments.form.preferredPharmacy' },
    healthPlan: { id: 'profile.section.insurance.healthPlan' },
    verificationDate: { id: 'profile.section.insurance.verificationDate' },
    race: { id: 'profile.fields.race' },
    ethnicity: { id: 'profile.fields.ethnic' },
  },
};

// TODO:
export const SCREEN_TITLES = {
  [ROUTES.PATIENT_VIEW_PROFILE]: { id: 'routes.patientViewProfile' },
  [ROUTES.PROVIDER_PROFILE]: { id: 'routes.providerViewProfile' },
  [ROUTES.PATIENT_PROFILE]: { id: 'routes.userViewProfile' },
  [ROUTES.USER_PROFILE]: { id: 'routes.userViewProfile' },
  [ROUTES.PROVIDER_MEMBER_PROFILE]: { id: 'routes.providerMemberProfile' },
  [ROUTES.FAMILY_MEMBER_PROFILE]: { id: 'routes.familyMemberProfile' },
  [ROUTES.TEAM_MEMBER_PROFILE]: { id: 'routes.familyMemberProfile' },
  [ROUTES.SURVEYS_GENERAL_SUB_PATH]: { id: 'routes.generalSurveys' },
  [ROUTES.PARENT_PROVIDER]: { id: 'routes.parentProvider' },
  [ROUTES.PATIENT_INFO]: { id: 'routes.patientInfo' },
  [ROUTES.PATIENT_HEALTHBOARD]: { id: 'routes.patientHealthboard' },
  [ROUTES.PROVIDER_INFO]: { id: 'routes.providerInfo' },
  [ROUTES.PROFILE_SETTINGS]: { id: 'routes.settings' },
  [ROUTES.PROFILE_PAYMENT_METHODS]: { id: 'routes.paymentMethods' },
  [ROUTES.SUPPORT]: { id: 'routes.support' },
  [ROUTES.PROFILE_DOCUMENTATION]: { id: 'routes.documentation' },
  [ROUTES.CIRCLE_OF_CARE]: { id: 'routes.circleOfCare' },
  [ROUTES.SURVEYS_GENERAL_SUB_PATH]: { id: 'routes.data' },
  [ROUTES.PROGRAM]: { id: 'routes.program' },
};

export const INTRO = {
  hints: {
    common: {
      logout: { id: 'intro.common.logout' },
      circlesMenu: { id: 'intro.common.circlesMenu' },
    },
    circles: {
      inviteFamilyMember: { id: 'intro.circles.inviteFamilyMember' },
      assignCaregiver: { id: 'intro.circles.assignCaregiver' },
      inviteProviderMember: { id: 'intro.circles.inviteProviderMember' },
      removeProviderMember: { id: 'intro.circles.inviteFamilyMember' },
    },
    messages: {
      searchChat: { id: 'intro.messages.searchChat' },
      selectChat: { id: 'intro.messages.selectChat' },
      selectChannel: { id: 'intro.messages.selectChannel' },
      generalChannel: { id: 'intro.messages.generalChannel' },
      familyChannel: { id: 'intro.messages.familyChannel' },
      providerChannel: { id: 'intro.messages.providerChannel' },
      typeFilter: { id: 'intro.messages.typeFilter' },

      typeMessage: { id: 'intro.messages.typeMessage' },
      answerSurvey: { id: 'intro.messages.answerSurvey' },
      patientName: { id: 'intro.messages.patientName' },
      patientContext: { id: 'intro.messages.patientContext' },
      patientProgram: { id: 'intro.messages.patientProgram' },
      programFilter: { id: 'intro.messages.programFilter' },
    },
  },
};

export const USER_STATUSES = [
  {
    status: USER_STATUS_INVITED,
    text: 'Invited',
  },
  {
    status: USER_STATUS_CREATED,
    text: 'Not invited',
  },
  {
    status: USER_STATUS_JOINED,
    text: 'Joined',
  },
];

export const COMMUNITY_TYPE_STRINGS = [
  {
    type: COMMUNITY_TYPES.public,
    text: { id: 'community.type.public' },
  },
  {
    type: COMMUNITY_TYPES.private,
    text: { id: 'community.type.private' },
  },
  {
    type: COMMUNITY_TYPES.global,
    text: { id: 'community.type.global' },
  },
];

export const COMMUNUNNITY_NEW_POST = {
  title: { id: 'community.newPost.title' },
  editTitle: { id: 'community.newPost.edit.title' },
  caption: { id: 'community.newPost.caption' },
  attachImage: { id: 'community.newPost.attachImage' },
  attachURL: { id: 'community.newPost.attachURL' },
  addPost: { id: 'community.newPost.addPost' },
  editPost: { id: 'community.newPost.editPost' },
  fileError: { id: 'community.newPost.fileError' },
  noPreview: { id: 'community.newPost.noPreview' },
  urlError: { id: 'community.newPost.urlError' },
  enterUrl: { id: 'community.newPost.enterUrl' },
  addPhoto: { id: 'community.newPost.addPhoto' },
  maxAttachmentNumber: { id: 'community.newPost.maxAttachmentNumber' },
  allowedFormatError: { id: 'community.newPost.allowedFormatError' },
  sendForApproval: { id: 'community.newPost.sendForApproval' },
};

export const COMMUNITY_POST_MENU = {
  editPost: { id: 'community.postMenu.editPost' },
  deletePost: { id: 'community.postMenu.deletePost' },
  confirmDeleteMessage: { id: 'community.postMenu.confirmDeleteMessage' },
  report: { id: 'community.postMenu.report' },
};

export const COMMUNITY_COMMENT_MENU = {
  editComment: { id: 'community.commentMenu.editComment' },
  deleteComment: { id: 'community.commentMenu.deleteComment' },
  confirmDeleteComment: { id: 'community.commentMenu.confirmDeleteComment' },
  report: { id: 'community.commentMenu.report' },
  shareLink: { id: 'community.commentMenu.shareLink' },
};

export const COMMUNITY_COMMENTS = {
  commentWasDeleted: { id: 'community.comments.commentWasDeleted' },
  commentWasDeletedByModerator: {
    id: 'community.comments.commentWasDeletedByModerator',
  },
};

export const COMMUNITY_AUTHOR_ROLE = {
  moderator: { id: 'community.roles.moderator' },
  member: { id: 'community.roles.member' },
};

export const COMMUNITIES_COMMON = {
  fromOrganization: { id: 'communities.title.fromOrganization' },
  otherCommunities: { id: 'communities.title.otherCommunities' },
  seeAll: { id: 'communities.title.seeAll' },
  posts: { id: 'communities.title.posts' },
  joinRequests: { id: 'communities.title.joinRequests' },
  invites: { id: 'communities.title.invites' },
  share: { id: 'communities.title.share' },
  join: { id: 'communities.title.join' },
  signUpToJoin: { id: 'communities.title.signUpToJoin' },
  requested: { id: 'communities.title.requested' },
  seeNewPosts: { id: 'communities.title.seeNewPosts' },
};

export const DIALOG_TITLE = {
  joinCircle: { id: 'dialog.titles.joinCircle' },
  noPatients: { id: 'dialog.common.noPatients' },
  addDependent: { id: 'dialog.titles.addDependent' },
  assign: { id: 'dialog.common.assign' },
  addPatient: { id: 'dialog.common.addPatient' },
  addNewPatient: { id: 'dialog.common.addNewPatient' },
  defaultPatientAssign: { id: 'dialog.common.defaultPatient' },
  assignProviderToPatient: { id: 'dialog.titles.assignProviderToPatient' },
  assignProviderOrTeamToPatient: {
    id: 'dialog.titles.assignProviderOrTeamToPatient',
  },
  defaultProviderAssign: { id: 'dialog.common.defaultProvider' },
  assignProvider: { id: 'dialog.common.assignProvider' },
  assignProviderOrTeam: { id: 'dialog.common.assignProviderOrTeam' },
  searchProvider: { id: 'dialog.common.searchProvider' },
  searchPatient: { id: 'dialog.common.searchPatient' },
  inviteCaregiver: { id: 'dialog.common.inviteCaregiver' },
  addPatientTitle: { id: 'dialog.titles.addPatient' },
  emergencyContactTitle: { id: 'dialog.titles.emergencyContact' },
  andOr: { id: 'dialog.titles.andOr' },
  and: { id: 'dialog.titles.and' },
  join: { id: 'dialog.titles.join' },
  accessRequested: { id: 'dialog.titles.accessRequested' },
  addAnotherPatient: { id: 'dialog.common.addAnotherPatient' },
  copiedToClipboard: { id: 'dialog.titles.copiedToClipboard' },
  shareableLink: { id: 'dialog.titles.shareableLink' },
  alreadyMember: { id: 'dialog.common.alreadyMember' },
};

export const SUCCESS_JOIN_CIRCLE = { id: 'dialog.success.joinCircle' };

export const SURVEYS_ASSIGNMENT_TITLE = {
  [ASSIGNMENT_METHOD.PROGRAM]: { id: 'surveys.method.program' },
  [ASSIGNMENT_METHOD.PROVIDER]: { id: 'surveys.method.provider' },
  [ASSIGNMENT_METHOD.BY_SYSTEM]: { id: 'surveys.method.system' },
  [ASSIGNMENT_METHOD.PRE_VISIT_FORM]: { id: 'surveys.preVisit.preVisitForm' },
  [ASSIGNMENT_METHOD.REFERRAL_FORM]: { id: 'surveys.method.referralForm' },
};

export const SURVEYS_ASSIGNMENT_DESC = {
  [ASSIGNMENT_METHOD.PROGRAM]: { id: 'surveys.desc.program' },
  [ASSIGNMENT_METHOD.PROVIDER]: { id: 'surveys.desc.provider' },
  [ASSIGNMENT_METHOD.BY_SYSTEM]: { id: 'surveys.desc.system' },
  [ASSIGNMENT_METHOD.PRE_VISIT_FORM]: { id: 'surveys.desc.system' },
  [ASSIGNMENT_METHOD.REFERRAL_FORM]: { id: 'surveys.desc.provider' },
};

export const TODO_ASSIGNMENT_TITLE = {
  [TODO_ASSIGNMENT_METHOD.SYSTEM]: { id: 'surveys.method.system' },
  [TODO_ASSIGNMENT_METHOD.PROVIDER]: { id: 'surveys.method.provider' },
  [TODO_ASSIGNMENT_METHOD.EMPLOYER]: { id: 'surveys.method.employer' },
};

export const SUCCESS_SENT_DOCUMENT_TO_EMAIL = {
  id: 'patient.portal.healthRecord.shareToEmailSuccess',
};

export const DEFAULT_EMPTY_VALUE = '-';



// WEBPACK FOOTER //
// ./src/constants/strings.js